import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

export const SubscriptionLoadingSkeleton = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Current Plan Card Skeleton */}
      <Card className="bg-black/40 border-white/10">
        <CardHeader className="space-y-3">
          <div className="flex items-center justify-between">
            <Skeleton className="h-6 w-40 bg-white/10" />
            <Skeleton className="h-6 w-24 bg-white/10 rounded-full" />
          </div>
          <Skeleton className="h-10 w-3/4 bg-white/10" />
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Skeleton className="h-4 w-24 bg-white/10" />
              <Skeleton className="h-6 w-32 bg-white/10" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-28 bg-white/10" />
              <Skeleton className="h-6 w-36 bg-white/10" />
            </div>
          </div>
          <div className="flex gap-3 pt-4">
            <Skeleton className="h-10 flex-1 bg-white/10 rounded-lg" />
            <Skeleton className="h-10 w-32 bg-white/10 rounded-lg" />
          </div>
        </CardContent>
      </Card>

      {/* Timeline Skeleton */}
      <Card className="bg-black/40 border-white/10">
        <CardHeader>
          <Skeleton className="h-6 w-48 bg-white/10" />
        </CardHeader>
        <CardContent className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex gap-4 items-start">
              <Skeleton className="h-10 w-10 rounded-full bg-white/10 flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-5 w-3/4 bg-white/10" />
                <Skeleton className="h-4 w-1/2 bg-white/10" />
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
};